import { Component, OnInit,HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonFunctions } from 'src/app/shared/common-functions';
import { PaymentGatewayService } from 'src/app/shared/services/payment-gateway.service';
import { PaymentStatusDialogComponent } from 'src/app/shared/components/payment-status-dialog/payment-status-dialog.component';
import { ViewCartService } from 'src/app/shared/services/view-cart.service';
import { Location, LocationStrategy} from '@angular/common';
import { StorageService } from 'src/app/shared/services/storage.service';
import { EncryptDecryptService } from 'src/app/core/services/encrypt-decrypt.service';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { map } from 'rxjs/operators';
import { OrdersService } from 'src/app/shared/services/orders.service';
@Component({
  selector: 'app-payment-activity',
  templateUrl: './payment-activity.component.html',
  styleUrls: ['./payment-activity.component.scss']
})
export class PaymentActivityComponent implements OnInit {
  public breadCrumbData: Array<Object> = [
    { title: 'Starbucks Pay', path: '' }
  ];
  public queryParams: any;
  public orderStatusId: any;
  public pgOrderStatus: string = '';
  public orderStatus: string = '';
  public orderId: any;
  public count = 0;
  public paymentProcess: boolean = true;
  public timeOut;
  public paymentDetails = JSON.parse(localStorage.getItem('paymentModeDetails'));
  constructor(
    private location: Location,
    public dialog: MatDialog,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private commonFunction: CommonFunctions,
    private viewCartService: ViewCartService,
    private storageService: StorageService,
    private encryptDecryptService: EncryptDecryptService,
    private paymentGatewayService: PaymentGatewayService,
    private ordersService: OrdersService,
    public firestore: AngularFirestore,
    private locat: LocationStrategy,
  ) {

    if(sessionStorage.getItem('PaymentBack') == 'PAYMENT_BACK'){
       this.router.navigate(['/ordering'])
    }else{
      activeRoute.queryParams.subscribe((params) =>
      this.queryParams = params
    );
      this.orderStatusId = this.queryParams['status_id']
      this.pgOrderStatus = this.queryParams['status']
      this.orderId = this.queryParams['order_id'];
      this.location.replaceState('/payment-activity');
      if (this.orderStatusId == '21') {
        this.location.replaceState('/payment-activity');
        (this.paymentDetails[0].paymentMode === 'CASH' || this.paymentDetails[0].paymentMode === 'MANUAL_EDC') ? this.commitOrderCashStatus() : this.checkFireStore(this.orderId);
      } else if (this.orderStatusId == '27') {
        this.showPaymentStatus('cart');
      } 
      else {
        this.showPaymentStatus('cart');
      }
    }
  }
  ngOnInit(): void {
    let browserBack = JSON.parse(sessionStorage.getItem('browserBack'))
    if (browserBack) {
      this.router.navigate(['/ordering'])
    }
  }
  commitOrderStatus() {
    let req = {
      "orderId": this.encryptDecryptService.encryptData(this.orderId),
      "paymentMethod": this.paymentDetails[0].paymentMode,
      "txnType": "Fnb",
      "paymentStatus": this.pgOrderStatus === 'CHARGED' ? 'PaymentSuccess' : 'PaymentFailure',
      "cardNumber": this.paymentDetails[0].paymentMode === 'MSR' ? this.encryptDecryptService.encryptData(this.paymentDetails[0].data.strLongCardNumber) : null
    }
    this.paymentGatewayService.commitStatus(req).subscribe((result) => {
      sessionStorage.removeItem('reloadCardPay')
      sessionStorage.removeItem('amountToReload')
      sessionStorage.setItem('PaymentBack','PAYMENT_BACK');
      this.deleteBasket();
      sessionStorage.setItem('orderId', this.encryptDecryptService.encryptData(this.orderId))
      this.router.navigate(['/order-track']);
    }, (error) => {
      sessionStorage.removeItem('reloadCardPay')
      sessionStorage.removeItem('amountToReload')
      this.commonFunction.processErrorMessage(error, 'failure');
      this.router.navigate(['/cart']);
    })
  }
  /**
* Method to check order status in real time db
 @param orderId of the order for Cash
*/
  commitOrderCashStatus() {
    let req = {
      "orderId":this.encryptDecryptService.encryptData(this.orderId),
      "paymentMethod": this.paymentDetails[0].paymentMode,
      "txnType": "Fnb",
      "paymentStatus": 'PaymentSuccess',
    }
    this.paymentGatewayService.commitStatusForCash(req).subscribe((result) => {
      sessionStorage.removeItem('reloadCardPay');
      sessionStorage.removeItem('amountToReload');
      sessionStorage.setItem('PaymentBack','PAYMENT_BACK');
      this.deleteBasket();
      sessionStorage.setItem('orderId', this.encryptDecryptService.encryptData(this.orderId))
      this.router.navigate(['/order-track']);
    }, (error) => {
      sessionStorage.removeItem('reloadCardPay')
      sessionStorage.removeItem('amountToReload')
      this.commonFunction.processErrorMessage(error, 'failure');
      this.router.navigate(['/cart']);
    })
  }

  /**
* Method to check order status in real time db
@param orderId of the order
*/
  checkFireStore(orderId) {
    this.firestore.collection('orders').doc(orderId).snapshotChanges().pipe(map(action => {
      const data = action.payload.data() as any;
      return data
    })).subscribe(data => {
      if (data) {
        if (data.orderStatus === 'CHARGED') {
          this.getStatus(orderId);
          clearTimeout(this.timeOut);
        } else {
          this.timeOut = setTimeout(() => {
            this.showPaymentStatus('cart');
          }, 12000);
        }
      } else {
        this.getStatus(orderId);
      }
    }, (error) => {
      this.getStatus(orderId);
    })
  }
  /**
* Method to check order status
@param orderId of the order
*/
  getStatus(orderId) {
    this.ordersService.getOrderStatus(orderId).subscribe(res => {
      if (res['response']['orderStatus'] === "COMPLETED") {
        sessionStorage.removeItem('reloadCardPay')
        sessionStorage.removeItem('amountToReload')
        this.deleteBasket();
        sessionStorage.setItem('orderId', this.encryptDecryptService.encryptData(orderId))
        this.router.navigate(['/order-track']);
      } else {
        if (this.count === 0) {
          setTimeout(() => {
            this.count++
            this.getStatus(orderId)
          }, 120000);
        } else {
          this.showPaymentStatus('cart');
        }
      }
    }, (error) => {
      sessionStorage.removeItem('reloadCardPay')
      sessionStorage.removeItem('amountToReload')
      this.commonFunction.processErrorMessage(error, 'failure');
      this.router.navigate(['/cart']);
    })
  }
  /**
* Method for deleting basket
*/
  deleteBasket() {
    let basketId = this.storageService.getBasketId();
    if (basketId) {
      let data = {
        'basketId': basketId
      }
      this.viewCartService.deleteBasket(data).subscribe(res => {
        localStorage.removeItem('snackbarData');
        this.storageService.clearBasketId();
        sessionStorage.removeItem('finalReqBodyArray');
        this.storageService.removeOrderType();
      }, (error) => {
      })
    }
  }
  showPaymentStatus(module) {
    this.paymentProcess = false;
    const dialogRef = this.dialog.open(PaymentStatusDialogComponent, {
      width: '744px',
      panelClass: "payment-fail-dialog",
      data: module,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
}
